const getNumberColor = (value: number | undefined): string => {
  return value
    ? value > 0
      ? 'PositiveChange'
      : 'NegativeChange'
    : 'CasperGrey';
};

export default getNumberColor;
